"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackifyQueue = void 0;
const tslib_1 = require("tslib");
class TrackifyQueue {
    constructor() {
        this.state = {
            canRun: false,
            processing: false
        };
        this.eventQueue = [];
    }
    onProcessed(callback) {
        this.runCallback = callback;
    }
    push(event) {
        this.eventQueue.push(event);
        this.process();
    }
    run() {
        this.state.canRun = true;
        this.process();
    }
    process() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.eventQueue.length === 0) {
                return;
            }
            if (!this.state.canRun || this.state.processing) {
                return;
            }
            this.state.processing = true;
            const event = this.eventQueue.shift();
            if (typeof event === 'undefined') {
                return;
            }
            if (this.runCallback) {
                this.runCallback.call({}, event);
            }
            this.state.processing = false;
            this.process();
        });
    }
}
exports.TrackifyQueue = TrackifyQueue;
//# sourceMappingURL=trackify-queue.js.map